// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_w7J","cls2":"TopBar-cls2_cRm TopBar-cls1_w7J"};